import { ApiKeyList } from '@/components/ApiKeyList';
import { PageHeader } from '@/components/PageHeader';

export function ApiKeysPage() {
  return (
    <div className="space-y-6">
      <PageHeader title="API Keys" description="Keys the external SaaS uses to call the bridge." />
      <ApiKeyList />
    </div>
  );
}